import React, { useEffect, useState } from "react";
import CareerNavbar from "./CareerNavbar";
import Footer from "./Footer";
import "../App.css";
import "./ApplicationForm.css";
import axios from "axios";
import { BiCloudUpload, BiRightArrowAlt } from "react-icons/bi";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";

const ApplicationForm = () => {
  const [showThankYou, setShowThankYou] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const queryClient = useQueryClient();
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    current_location: "",
    job_id: "",
    companyCode: "JDH",
    message: "",
    resume: null,
    experience: "",
    vertical_id: 15
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      cv: e.target.files[0],
    }));
  };

  const applyMutation = useMutation({
    mutationFn: async (data) => {
      const response = await axios.post(
        "https://api.nityagroup.tech/api/apply",
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      return response.data;
    },

    onSuccess: () => {
      setShowThankYou(true);

      // reset form
      setFormData({
        fullName: "",
        email: "",
        phone: "",
        city: "",
        position: "",
        linkedin: "",
        message: "",
        job_id: "",
        cv: null,
        vertical_id:""
      });

      queryClient.invalidateQueries(["candidates"]);
    },

    onError: (error) => {
      alert(error.response?.data?.message || "Submission failed");
    },
  });

  const { data: jobs, isLoading } = useQuery({
    queryKey: ["jobs-list"],
    queryFn: async () => {
      const res = await axios.get("https://api.nityagroup.tech/api/jobs-list");
      return (res.data || []).filter(
        (v) => v.vertical_id === 15
      );

    },
  });

  

  const handleSubmit = (e) => {
    e.preventDefault();

    const data = new FormData();

    data.append("full_name", formData.fullName);
    data.append("email", formData.email);
    data.append("phone", formData.phone);
    data.append("current_location", formData.city);
    data.append("cover_letter", formData.message);
    data.append("experience", formData.experience); // agar future me add karna ho
    data.append("job_id", formData.job_id); // dynamic karo agar route se aa raha ho
    data.append("companyCode", formData.companyCode); // dynamic karo agar route se aa raha ho
    data.append("resume", formData.cv);
    data.append("vertical_id", formData.vertical_id);
    applyMutation.mutate(data);
  };
  return (
    <>
      <CareerNavbar />

      <div className="application-form-section d-flex align-items-center justify-content-center">
        <div className="container application-form-container">
          {/* Header */}
          <div className="text-start mb-5">
            <h1 className="application-form-title mb-3">Join #TeamJeevandan</h1>
            <p className="application-form-subtitle">
              Think outside the box? We built a whole jungle for it!
              <br />
              Apply today 👇
            </p>
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit}>
            {/* Full Name */}
            <div className="mb-4">
              <label
                htmlFor="fullName"
                className="form-label form-label-custom"
              >
                Full Name <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control form-control-lg rounded-3 shadow-sm bg-white form-control-custom"
                id="fullName"
                name="fullName"
                placeholder="Enter your full name"
                value={formData.fullName}
                onChange={handleChange}
                required
              />
            </div>

            {/* Email Address */}
            <div className="mb-4">
              <label htmlFor="email" className="form-label form-label-custom">
                Email Address <span className="text-danger">*</span>
              </label>
              <input
                type="email"
                className="form-control form-control-lg rounded-3 shadow-sm bg-white form-control-custom"
                id="email"
                name="email"
                placeholder="example@domain.com"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            {/* Phone Number */}
            <div className="mb-4">
              <label htmlFor="phone" className="form-label form-label-custom">
                Phone Number <span className="text-danger">*</span>
              </label>
              <input
                type="tel"
                className="form-control form-control-lg rounded-3 shadow-sm bg-white form-control-custom"
                id="phone"
                name="phone"
                placeholder="+91 98765 43210"
                value={formData.phone}
                onChange={handleChange}
                required
              />
            </div>

            {/* Current City */}
            <div className="mb-4">
              <label htmlFor="city" className="form-label form-label-custom">
                Current City <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control form-control-lg rounded-3 shadow-sm bg-white form-control-custom"
                id="city"
                name="current_location"
                placeholder="Enter your current Location"
                value={formData.current_location}
                onChange={handleChange}
                required
              />
            </div>

            {/* Desired Position */}
            <div className="mb-4">
              <label
                htmlFor="position"
                className="form-label form-label-custom"
              >
                Desired Position <span className="text-danger">*</span>
              </label>

              <select
                className="form-select form-select-lg rounded-3 shadow-sm bg-white form-control-custom"
                id="job_id"
                name="job_id"
                value={formData.job_id}
                onChange={handleChange}
                required
              >
                <option value="" disabled>
                  Select a position
                </option>

                {jobs?.length > 0 &&
                  jobs.map((job) => (
                    <option key={job.id} value={job.id}>
                      {job.job_title}
                    </option>
                  ))}
              </select>
            </div>

            {/* LinkedIn Profile */}
            {/*     <div className="mb-4">
              <label
                htmlFor="linkedin"
                className="form-label form-label-custom"
              >
                LinkedIn Profile
              </label>
              <input
                type="url"
                className="form-control form-control-lg rounded-3 shadow-sm bg-white form-control-custom"
                id="linkedin"
                name="linkedin"
                placeholder="https://linkedin.com/in/your-profile"
                value={formData.linkedin}
                onChange={handleChange}
              />
            </div> */}

            {/* Upload CV/Portfolio */}
            <div className="mb-4">
              <label htmlFor="cv" className="form-label form-label-custom">
                Upload CV/Portfolio <span className="text-danger">*</span>
              </label>
              <div className="file-upload-wrapper position-relative">
                <input
                  type="file"
                  className="form-control position-absolute top-0 start-0 w-100 h-100 opacity-0 cursor-pointer"
                  id="cv"
                  name="cv"
                  onChange={handleFileChange}
                  accept=".pdf,.doc,.docx"
                  required
                />
                <div className="file-upload-area p-5 rounded-4 border-2 border-dashed bg-light text-center cursor-pointer hover-bg-light-dark transition-all">
                  <BiCloudUpload size={40} className="text-secondary mb-2" />
                  <p className="mb-1 fw-bold text-dark">
                    Click to choose a file or drag here
                  </p>
                  <p className="small text-muted mb-0">
                    Accepts .pdf, .doc, .docx files
                  </p>
                  <p className="small text-muted mb-0">Size limit: 5 MB</p>
                  {formData.cv && (
                    <p className="mt-2 text-success fw-bold small">
                      Selected: {formData.cv.name}
                    </p>
                  )}
                </div>
              </div>
            </div>

            {/* Message */}
            <div className="mb-5">
              <label htmlFor="message" className="form-label form-label-custom">
                Message
              </label>
              <textarea
                className="form-control form-control-lg rounded-3 shadow-sm bg-white form-control-custom"
                id="message"
                name="message"
                rows="4"
                placeholder="Tell us why you are a good fit for this position or share any other relevant information."
                value={formData.message}
                onChange={handleChange}
              ></textarea>
            </div>

            {/* Submit Button */}
            <div className="mb-5">
              <button
                type="submit"
                disabled={applyMutation.isPending}
                className="btn btn-launch btn-lg px-5 py-3 rounded-pill fw-bold d-flex align-items-center gap-2 hover-scale transition-all"
              >
                {applyMutation.isPending
                  ? "Submitting..."
                  : "Launch Your Career"}{" "}
                <BiRightArrowAlt size={20} />
              </button>
            </div>
          </form>
        </div>
      </div>
      {showThankYou && (
        <div className="thankyou-overlay">
          <div className="thankyou-box">
            <div className="checkmark">✓</div>
            <h3>Application Submitted!</h3>
            <p>
              Thank you for applying. Our team will review your application and
              get back to you soon.
            </p>
            <button
              className="close-btn"
              onClick={() => setShowThankYou(false)}
            >
              Close
            </button>
          </div>
        </div>
      )}
           
    </>
  );
};

export default ApplicationForm;
